import * as R from "ramda";

export const getContactPreferences = R.prop("contact_preference_attributes");
export const getDepartmentIDs = R.prop("department_ids");
export const getEmail = R.prop("email");
export const getFirstName = R.prop("first_name");
export const getIsGuest = R.propOr(true, "is_guest");
export const getName = R.prop("full_name");
export const getPhoneNumber = R.prop("phone_number");
export const isOktaUser = R.propOr(false, "is_okta_user?");
export const requiresTacAcceptance = R.propOr(false, "requires_tos_acceptance?");
const getRoleNames = R.propOr([], "role_names");
const hasRole = R.curry((role, user) => R.compose(R.includes(role), getRoleNames)(user));
export const isSuper = R.either(hasRole("superuser"), hasRole("superadmin"));
export const isSuperuser = hasRole("superuser");
export const isManager = hasRole("manager");

/**
 * user filtering
 *
 * @private
 * @param {String} search
 * @param {Object} user
 * @returns {Boolean}
 */
export const isSearchUser = (search, user) => {
  if (search) {
    return (
      user?.email?.toLocaleLowerCase().includes(search?.toLocaleLowerCase()) ||
      user?.first_name?.toLocaleLowerCase().includes(search?.toLocaleLowerCase()) ||
      user?.last_name?.toLocaleLowerCase().includes(search?.toLocaleLowerCase()) ||
      user?.full_name?.toLocaleLowerCase().includes(search?.toLocaleLowerCase())
    );
  }
  return true;
};

/**
 * for filtering OpenCounter staff
 *
 * @private
 * @param {Object} user
 * @returns {Boolean}
 */
export const isOpenCounterStaff = (user) => user.is_opencounter_staff || user["opencounter_staff?"];
